import React from "react"
import Ample from "../components/ample/ample"
import TickerDropDown from "../components/tickerdropdown"
import TradingViewChart from "../components/tradingview/chart"
import TradingViewSymbolOverview from "../components/tradingview/symboloverview"
import SocialPanel from "../components/stocktwits/socialpanel"
import { TOOLS, getToolPageTitle } from "../optiontools"

export default class TickerReportPage extends React.Component {
  state = {
    ticker: "AMZN"
  }

  tickerChanged = newTicker => {
    this.setState({ticker:newTicker});
  }

    render() {
        const seoDescription="Visualizations of stock price trends and social media sentiment for NASDAQ and NYSE tickers";
        return (
            <Ample  currPageTitle={getToolPageTitle(TOOLS.TICKER_REPORT)} seoDescription={seoDescription}  location={this.props.location.href}>
            <h1 style={{position: 'absolute', width: '1px', height: '1px', margin: '-1px', padding: 0, overflow: 'hidden', clip: 'rect(0,0,0,0)', border: 0}}>
                {getToolPageTitle(TOOLS.TICKER_REPORT)}
            </h1>
            <div className="row  " >  
                <div className="col-lg-8 col-sm-12 col-xs-12">
                    <div className="row" >
                        <div className="col-lg-12 col-sm-12 col-xs-12"  >
                            <div className="card" style={{minWidth:"380px"}}>
                            <div className="card-body">
                                <h4 className="card-title" style={{marginBottom: "8px", textTransform: 'none'}}>Ticker Report</h4>
                                <p style={{color: "#666", fontSize: "0.9rem", marginBottom: "16px"}}>
                                    Select a ticker to view price trends, technical analysis, and social sentiment.
                                </p>
                                <TickerDropDown OptionsOnly={false} excludeIndexes={true} defaultTicker={this.state.ticker}  onSelectedTickerChanged={this.tickerChanged} helperText=""/>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="row  "  >
                        <div className="col-lg-12 col-sm-12 col-xs-12"  >
                        <div className="card" >
                            <div className="card-body" style={{paddingBottom: "8px"}}>
                                <h4 className="card-title" style={{marginBottom: "8px", textTransform: 'none'}}>Technical Overview</h4>
                                <p style={{color: "#666", fontSize: "0.9rem", marginBottom: "12px"}}>
                                    Key metrics and technical indicators at a glance.
                                </p>
                            </div>
                            <TradingViewSymbolOverview ticker={this.state.ticker}/>
                        </div>
                        </div>
                    </div>
                    <div className="row"  >
                        <div className="col-lg-12 col-sm-12 col-xs-12"  >
                        <div className="card" style={{visibility:(this.state.ticker!=="")?'visible':'hidden'}} >
                            <div className="card-body" style={{paddingBottom: "8px"}}>
                                <h4 className="card-title" style={{marginBottom: "8px", textTransform: 'none'}}>Price Chart</h4>
                                <p style={{color: "#666", fontSize: "0.9rem", marginBottom: "12px"}}>
                                    Interactive price history with technical analysis tools.
                                </p>
                            </div>
                            <TradingViewChart width="100%" ticker={this.state.ticker}/>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-sm-12 col-xs-12">
                    <div style={{minWidth:"380px",maxWidth:"380px",visibility:(this.state.ticker!=="")?'visible':'hidden'}}>
                        <div className="card" style={{marginBottom: "20px"}}>
                            <div className="card-body">
                                <h4 className="card-title" style={{marginBottom: "8px", textTransform: 'none'}}>Social Sentiment</h4>
                                <p style={{color: "#666", fontSize: "0.9rem", marginBottom: "0px"}}>
                                    Real-time social media discussion and sentiment analysis.
                                </p>
                            </div>
                        </div>
                        <SocialPanel ticker={this.state.ticker} />
                    </div>
                </div>
            </div>
            </Ample>);
    }
}
